import { create } from "zustand";
import api from "../api/axios";


const useLeaveCountStore = create((set) => ({
  leaveCount: [],
  loading: false,
  error: null,

  fetchLeaveCount: async (employeeId) => {
    if (!employeeId) return;

    set({
      loading: true,
      error: null,
    });

    try {
      const response = await api.get(
        `/employees/${employeeId}/leaveCount`
      );

      set({
        leaveCount: response?.data?.data || [],
        loading: false,
        error: null,
      });

      return response?.data?.data || [];
    } catch (error) {
      console.error("Leave Count Error:", error);

      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch leave count";

      set({
        leaveCount: [],
        loading: false,
        error: message,
      });

      throw error;
    }
  },

  resetLeaveCount: () => {
    set({
      leaveCount: [],
      loading: false,
      error: null,
    });
  },
}));

export default useLeaveCountStore;